<!--
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:23
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-03-01 17:54:13
 * @FilePath     : \vue3-ts-mm\src\layout\components\navBar\index.vue
 * @Description  : 右上角 个人头像
-->

<template>
  <div class="navBar">
    <div class="navBarLang">
      <AppLocalePicker />
    </div>

    <a-dropdown class="ant-dropdown-link navBarLink">
      <span class="navBarSpan" @click.prevent>
        <a-avatar style="margin-right: 8px" :src="store.userInfoData.pic
          ? C.ApiImage + store.userInfoData.pic
          : inter.getImageUrl('no-avatar3.png')
          ">
          <template #icon>
            <UserOutlined />
          </template>
        </a-avatar>
        <span class="ant-dropdown-link">
          {{ userName }}
          <DownOutlined />
        </span>
      </span>
      <template #overlay>
        <a-menu>
          <!-- <a-menu-item key="0" @click="routerHome">
            <template #icon>
              <home-outlined />
            </template>
目标检测
</a-menu-item> -->
          <a-menu-item key="0" @click="routerInfo">
            <template #icon>
              <user-outlined />
            </template>
            {{ $t(`login.userInfo`) }}
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="3" @click="logout">
            <template #icon> <logout-outlined /> </template>
            {{ $t(`login.logOut`) }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import inter from '../../../utils/shared'
import C from '../../../utils/constants'
import { loginStore } from '../../../store/login'
import AppLocalePicker from '@/components/AppLocalePicker/index.vue'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()


const userName = ref<string>('')

const router = useRouter()
const route = useRoute()

const store = loginStore()

const routerHome = () => {
  router.push('/console/home')
}
/** 个人信息界面 */
const routerInfo = () => {
  router.push('/manage/account/settings')
}

onBeforeMount(() => {
  const user: string = localStorage.getItem('user') || '{}'
  let userInfo = JSON.parse(user)
  const { realname, username } = userInfo || {}
  userName.value = realname ? realname : username ? username : '未登录'
})

/** 退出登录 */
const logout = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('user')
  store.userInfo = null
  router.push(`/login?redirect=${route.fullPath}`)
}
</script>

<style lang="less">
@import url('./index.less');
</style>
